module.exports = {
  'en': {
    'HRAP31EC1': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'Appraiser"s Code',
      '40': 'Select List Emp.to be appraised',
      '50': 'Department Code',
      '60': 'Appraisal Group',
      '70': 'or Employee Code',
      '80': 'Seq.',
      '90': 'Emp. Code',
      '99': 'Appraisal For Employee',
      '100': 'Employee Name',
      '110': 'Completed',
      '120': 'Appraisal',
      '130': 'Appraisal Score',
      '140': 'Beh.',
      '150': 'Comp.',
      '160': 'KPI',
      '170': 'Total',
      '180': 'Status',
      '190': 'Completed Appraisal'
    },
    'HRAP31EC2': {
      '10': 'For Year',
      '20': 'App.No.',
      '30': 'Appraiser"s Code',
      '35': 'Type of Appraisal',
      '40': 'Employee Code',
      '45': 'App. Seq.',
      '50': 'Record Date',
      '60': 'Evaluate From',
      '70': 'To',
      '80': 'Detail of Appraisal Form',
      '90': 'No.of Completed Appraisal',
      '100': 'Persons',
      '110': 'Average Score',
      '120': 'Average',
      '130': 'Weight',
      '140': 'Score',
      '150': 'Behavior',
      '160': 'Competency',
      '170': 'KPI',
      '180': 'Type of Appraisal',
      '190': 'Appraisal Status',
      '200': 'Aprroved By',
      '210': 'Approve Date',
      '220': '360 Degree',
      '230': 'Top Down'
    },
    'HRAP31EC3': {
      '10': 'For Year',
      '20': 'App. No.',
      '25': 'App. Seq.',
      '30': 'App. Seq.',
      '35': 'Type of Appraisal',
      '40': 'Appraiser"s Code',
      '45': 'Job Description',
      '50': 'Employee Code',
      '60': 'Appraisal Date',
      '70': 'Appraisal From',
      '75': 'Position',
      '77': 'Appraisal Status',
      '80': 'To',
      '82': 'Competency',
      '90': 'AP Form No.',
      '100': 'Section no.',
      '110': 'No.',
      '120': 'Item Description',
      '130': 'Item Details',
      '140': 'Deduction',
      '150': 'Weight',
      '160': 'Grad',
      '165': 'Score',
      '170': 'Score',
      '180': 'Total',
      '190': 'Grand Total',
      '200': 'Critical area to be improved',
      '201': 'Score',
      '205': 'Grad',
      '210': 'Appraiser"s Comment',
      '220': 'Employee"s Comment',
      '225': 'Critical area to be improved',
      '230': 'Details of Appraisal from others',
      '240': 'Grad',
      '250': 'Description',
      '260': 'Definitions',
      '270': 'Score',
      '280': 'Detail of Deduction Score',
      '290': 'Abnormal attendance/leave/misconduct',
      '300': 'Unit',
      '310': 'Deduction Score',
      '320': 'Other Details',
      '330': 'Tr course required'
    },
    'HRAP31EC4': {
      '10': 'For Year',
      '20': 'App. No.',
      '25': 'Seq.No.',
      '30': 'Seq.No.',
      '40': 'Appraisor"s Code',
      '50': 'Employee Code',
      '60': 'Appraisal Date',
      '70': 'Appraisal From',
      '80': 'To',
      '90': 'Position',
      '100': 'Job Desc.',
      '110': 'Type of Competency',
      '120': 'Type of Skill',
      '130': 'Detail of Appraisal Form (Competency)',
      '140': 'คำจำกัดความ',
      '150': 'Req.',
      '160': 'Grade',
      '170': 'Score',
      '180': 'Gap',
      '190': 'Total',
      '200': 'Total',
      '205': 'Grade',
      '210': 'Critical area to be improved',
      '220': 'Appraiser"s Comments',
      '225': 'Critical area to be improved',
      '230': 'Employee"s Comment',
      '240': 'Other Detail',
      '250': 'หลักสูตรที่ควรอบรม',
      '260': 'Details of Other Appraisal',
      '270': 'Level',
      '280': 'Index',
      '290': 'Indicators Detail',
      '300': 'Score'
    },
    'HRAP31EC41': {
      '150': 'This App.',
      '160': 'Avg.',
      '180': 'Details of Evaluation',
      '190': 'Type of Competency',
      '210': 'Weight',
      '320': 'Score',
      '900': 'Score'
    },
    'HRAP31EC5': {
      '10': 'For Year',
      '20': 'App.No.',
      '25': 'Seq.No.',
      '30': 'Seq.No.',
      '40': 'Appraiser I.D',
      '50': 'Employee Code',
      '60': 'Record Date',
      '70': 'Appraisal From',
      '80': 'To',
      '82': 'KPI',
      '90': 'Detail of Appraisal Form (KPI)',
      '100': 'Seq.',
      '110': 'Detail of KPI',
      '120': 'Status of work',
      '130': 'Weight',
      '140': 'Score',
      '150': 'Avg. Score',
      '160': 'Company KPI',
      '170': 'Net Score',
      '180': 'Total',
      '190': 'Other Information',
      '200': 'Details Of Other Appraisal',
      '210': 'Last Year Appraisal',
      '220': 'Company KPI'
    },
    'HRAP31EC6': {
      '10': 'For Year',
      '20': 'App.l No.',
      '25': 'Appraisal Seq.',
      '30': 'Appraisal Seq.',
      '35': 'Appraiser i.d',
      '40': 'Employee Code',
      '50': 'KPI Number',
      '55': 'Appraiser i.d',
      '60': 'Detail of KPI',
      '70': 'Target Value',
      '80': 'Achieved',
      '90': 'Unit',
      '100': 'Unit',
      '110': 'Value',
      '120': 'Total Value',
      '130': 'Status',
      '140': 'Weight',
      '150': 'Target Date',
      '160': 'Evaluation Score',
      '170': 'รายละเอียดงานที่ต้องทำ',
      '180': 'Item No.',
      '190': 'รายละเอียดงานที่ต้องทำ',
      '200': 'Achieved Value',
      '210': 'Other Information',
      '220': 'Training Course',
      '230': 'รายละเอียดงานที่ทำ',
      '240': 'No.',
      '250': 'Grade',
      '260': 'Achieved Value',
      '270': 'Score'
    },
    'HRAP31EC7': {
      '10': 'For Year',
      '20': 'App.No.',
      '25': 'Seq.No.',
      '30': 'For Employee',
      '40': 'Seq.',
      '50': 'Detail of KPI',
      '60': 'Weight',
      '70': 'Score',
      '80': 'Avg. Score',
      '90': 'Total'
    },
    'HRAP31EC32': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'App. Seq.',
      '40': 'Appraiser"s Code',
      '50': 'Employee Code',
      '60': 'Appraisal Date',
      '70': 'Appraisal From',
      '80': 'To',
      '90': 'List of Training Course Required',
      '100': 'Course Code',
      '110': 'Course Name',
      '120': 'Category',
      '130': 'Type Of Development',
      '140': 'No. Atten./Class',
      '145': 'Details of Other Appraisal',
      '150': 'Gap Competency Course',
      '160': 'Gap Competency Course',
      '170': 'Skill',
      '180': 'Detail of Skill',
      '190': 'Level',
      '200': 'Course Code',
      '210': 'Course Name'
    },
    'HRAP31EC9': {
      '10': 'Detail of Work Done',
      '20': 'For Year',
      '30': 'App.No.',
      '40': 'For Employee',
      '50': 'KPI Number',
      '60': 'Detail of KPI',
      '70': 'Target Value',
      '80': 'Unit',
      '90': 'Value',
      '100': 'Date',
      '110': 'Achieved Value',
      '120': 'Value',
      '130': 'Net Value'
    },
    'HRAP31EC10': {
      '10': 'For Year',
      '20': 'No.',
      '30': 'For Department',
      '40': 'KPI No.',
      '50': 'KPI Detail',
      '60': 'Target',
      '70': 'Indicators',
      '80': 'Value',
      '90': 'Target Date',
      '100': 'Weight',
      '110': 'Value Is',
      '120': 'Score',
      '130': 'Net Score',
      '140': 'รายละเอียดงานที่ต้องทำ',
      '150': 'No.',
      '160': 'Detail',
      '170': 'Work completed'
    },
    'HRCO2FEC1': {
      '10': 'Add Other Data',
      '20': 'For Table',
      '30': 'Field',
      '40': 'Description',
      '50': 'Data Type',
      '60': 'Value'
    },
    'HRCO2FEC2': {
      '5': 'Add Other Data',
      '10': 'Function Name',
      '20': 'Or Table Name',
      '30': 'For Table',
      '40': 'Table Comment',
      '50': '-Added column',
      '60': ' will be  initiated with \'USR_\'',
      '70': '- Column name should not be longer than  8 character',
      '80': 'Field Name',
      '90': 'Commemt',
      '100': 'Data Type',
      '110': 'Size',
      '120': 'Integer',
      '130': 'Decimal',
      '140': 'Primary (Y,N)',
      '150': 'Standard (Y,N)'
    }
  },
  'th': {
    'HRAP31EC1': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'รหัสผู้ประเมิน',
      '40': 'เลือกพนักงานเพื่อประเมิน',
      '50': 'รหัสหน่วยงาน',
      '60': 'กลุ่มประเมิน',
      '70': 'หรือ รหัสพนักงาน',
      '80': 'ลำดับที่',
      '90': 'รหัสพนักงาน',
      '99': 'การประเมินผลการปฏิบัติงานของพนักงาน',
      '100': 'ชื่อ - นามสกุล',
      '110': 'จำนวนคน',
      '120': 'ประเมินแล้ว',
      '130': 'คะแนนเฉลี่ย',
      '140': 'Beh.',
      '150': 'Comp.',
      '160': 'KPI',
      '170': 'รวม',
      '180': 'สถานะ',
      '190': 'จำนวนคนประเมินแล้ว'
    },
    'HRAP31EC2': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'รหัสผู้ประเมิน',
      '35': 'ประเภทการประเมิน',
      '40': 'รหัสพนักงาน',
      '45': 'ลำดับที่',
      '50': 'วันที่ประเมิน',
      '60': 'ประเมินตั้งแต่',
      '70': 'ถึง',
      '80': 'รายละเอียดการประเมิน',
      '90': 'จำนวนคนที่ประเมินแล้ว',
      '100': 'คน',
      '110': 'คะแนนเฉลี่ยที่ได้',
      '120': 'คะแนนเฉลี่ย',
      '130': 'น้ำหนัก',
      '140': 'คะแนน',
      '150': 'Behavior',
      '160': 'Competency',
      '170': 'KPI',
      '180': 'ประเภทการประเมิน',
      '190': 'สถานะการประเมิน',
      '200': 'รหัสผู้อนุมัติ',
      '210': 'วันที่อนุมัติ',
      '220': '360 Degree',
      '230': 'Top Down'
    },
    'HRAP31EC3': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '25': 'ลำดับที่',
      '30': 'ลำดับที่',
      '35': 'ประเภทการประเมิน',
      '40': 'รหัสผู้ประเมิน',
      '45': 'ลักษณะงาน',
      '50': 'รหัสพนักงาน',
      '60': 'วันที่ประเมิน',
      '70': 'ประเมินตั้งแต่',
      '75': 'ตำแหน่ง',
      '77': 'สถานะการประเมิน',
      '80': 'ถึง',
      '82': 'Competency',
      '90': 'แบบฟอร์มการประเมิน',
      '100': 'หัวข้อการประเมินสำหรับส่วนที่',
      '110': 'ข้อที่',
      '120': 'รายละเอียด',
      '130': 'คำจำกัดความ',
      '140': 'หักคะแนน',
      '150': 'น้ำหนัก',
      '160': 'เกรด',
      '165': 'คะแนน',
      '170': 'คะแนนที่ได้',
      '180': 'รวม',
      '190': 'รวมแบบฟอร์ม',
      '200': 'สิ่งที่ควรปรับปรุง',
      '201': 'คะแนนที่ได้',
      '205': 'เอกสารแนบ',
      '210': 'รายละเอียดเพิ่มเติมของหัวหน้างาน',
      '220': 'รายละเอียดเพิ่มเติมของพนักงาน',
      '225': 'รวมคะแนนส่วนที่ 2',
      '230': 'รายละเอียดการประเมินจากคนอื่น',
      '240': 'เกรด',
      '250': 'รายละเอียด',
      '260': 'คำจำกัดความ',
      '270': 'คะแนนที่ได้',
      '280': 'รายละเอียดการหักคะแนน',
      '290': 'ทำงานผิดปกติ/ลา/การผิดวินัย',
      '300': 'หน่วย',
      '310': 'คะแนนที่หัก',
      '320': 'รายละเอียดเพิ่มเติม',
      '330': 'หลักสูตรที่ควรอบรม'
    },
    'HRAP31EC4': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '25': 'ลำดับที่ประเมิน',
      '30': 'ลำดับที่ประเมิน',
      '40': 'รหัสผู้ประเมิน',
      '50': 'รหัสพนักงาน',
      '60': 'วันที่ประเมิน',
      '70': 'ประเมินตั้งแต่',
      '80': 'ถึง',
      '90': 'ตำแหน่ง',
      '100': 'ลักษณะงาน',
      '110': 'Type of Competency',
      '120': 'ทักษะ',
      '130': 'รายละเอียดการประเมิน (Competency)',
      '140': 'คำจำกัดความ',
      '150': 'ต้องการ',
      '160': 'เกรด',
      '170': 'คะแนนที่ได้',
      '180': 'Gap',
      '190': 'รวม',
      '200': 'คะแนนทั้งหมด',
      '205': 'เกรด',
      '210': 'สิ่งที่ควรปรับปรุง',
      '220': 'รายละเอียดเพิ่มเติมของหัวหน้างาน',
      '225': 'สิ่งที่ควรปรับปรุง',
      '230': 'รายละเอียดเพิ่มเติมของพนักงาน',
      '240': 'รายละเอียดเพิ่มเติม',
      '250': 'หลักสูตรที่ควรอบรม',
      '260': 'รายละเอียดการประเมินจากคนอื่น',
      '270': 'ระดับ',
      '280': 'การชี้วัด',
      '290': 'รายละเอียดการชี้วัด',
      '300': 'คะแนนที่ได้'
    },
    'HRAP31EC41': {
      '150': 'ครั้งนี้',
      '160': 'เฉลี่ย',
      '180': 'รายละเอียดการประเมิน Competency',
      '190': 'Type of Competency',
      '210': 'น้ำหนัก',
      '320': 'คะแนนที่ได้',
      '900': 'คะแนนที่ได้'
    },
    'HRAP31EC5': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '25': 'ลำดับที่ประเมิน',
      '30': 'ลำดับที่ประเมิน',
      '40': 'รหัสผู้ประเมิน',
      '50': 'รหัสพนักงาน',
      '60': 'วันที่ประเมิน',
      '70': 'ประเมินตั้งแต่',
      '80': 'ถึง',
      '82': 'KPI',
      '90': 'รายละเอียดการประเมิน (KPI)',
      '100': 'ลำดับ',
      '110': 'รายละเอียด KPI',
      '120': 'สถานะ',
      '130': 'น้ำหนัก',
      '140': 'คะแนนที่ได้',
      '150': 'คะแนนเฉลี่ย',
      '160': 'KPI หน่วยงาน',
      '170': 'คะแนนสุทธิ',
      '180': 'รวม',
      '190': 'รายละเอียดเพิ่มเติม',
      '200': 'รายละเอียดการประเมินจากคนอื่น',
      '210': 'การประเมินครั้งที่แล้ว',
      '220': 'รายละเอียด KPI องค์กร'
    },
    'HRAP31EC6': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '25': 'ลำดับที่ประเมิน',
      '30': 'ลำดับที่ประเมิน',
      '35': 'รหัสผู้ประเมิน',
      '40': 'รหัสพนักงาน',
      '50': 'ลำดับที่ KPI',
      '55': 'รหัสผู้ประเมิน',
      '60': 'รายละเอียด KPI',
      '70': 'เป้าหมายที่กำหนด',
      '80': 'บรรลุเป้าหมาย',
      '90': 'หน่วย',
      '100': 'หน่วย',
      '110': 'มูลค่า',
      '120': 'มูลค่ารวม',
      '130': 'สถานะ',
      '140': 'Weight',
      '150': 'Target Date',
      '160': 'เกรดที่ได้/ผลคะแนน',
      '170': 'รายละเอียดงานที่ต้องทำ',
      '180': 'ลำดับที่',
      '190': 'รายละเอียดงานที่ต้องทำ',
      '200': 'งานที่ทำสำเร็จ',
      '210': 'รายละเอียดเพิ่มเติม',
      '220': 'หลักสูตรที่ควรอบรม',
      '230': 'รายละเอียดงานที่ทำ',
      '240': 'ลำดับที่',
      '250': 'เกรด',
      '260': 'งานที่ทำสำเร็จ',
      '270': 'คะแนน'
    },
    'HRAP31EC7': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '25': 'ลำดับที่ประเมิน',
      '30': 'สำหรับพนักงาน',
      '40': 'ลำดับ',
      '50': 'รายละเอียด KPI',
      '60': 'น้ำหนัก',
      '70': 'คะแนนที่ได้',
      '80': 'คะแนนเฉลี่ย',
      '90': 'รวม'
    },
    'HRAP31EC32': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'ลำดับที่ประเมิน',
      '40': 'รหัสผู้ประเมิน',
      '50': 'รหัสพนักงาน',
      '60': 'วันที่ประเมิน',
      '70': 'ประเมินตั้งแต่',
      '80': 'ถึง',
      '90': 'หลักสูตรที่ควรอบรม',
      '100': 'รหัสหลักสูตร',
      '110': 'ชื่อหลักสูตร',
      '120': 'หมวด',
      '130': 'ประเภทการจัดอบรม',
      '140': 'จำนวนผู้อบรม/รุ่น',
      '145': 'หลักสูตรที่ควรอบรมจากคนอื่น',
      '150': 'หลักสูตรตาม Gap Competency',
      '160': 'หลักสูตรตาม Gap Competency',
      '170': 'ทักษะ',
      '180': 'รายละเอียด',
      '190': 'ระดับ',
      '200': 'รหัสหลักสูตร',
      '210': 'ชื่อหลักสูตร'
    },
    'HRAP31EC9': {
      '10': 'รายละเอียดงานที่ทำ',
      '20': 'สำหรับปี',
      '30': 'ครั้งที่',
      '40': 'สำหรับพนักงาน',
      '50': 'ลำดับที่ KPI',
      '60': 'รายละเอียด KPI',
      '70': 'เป้าหมายที่กำหนด',
      '80': 'หน่วย',
      '90': 'มูลค่า',
      '100': 'วันที่บันทึก',
      '110': 'ผลงานที่ทำได้',
      '120': 'มูลค่า',
      '130': 'มูลค่าสะสม'
    },
    'HRAP31EC10': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'สำหรับหน่วยงาน',
      '40': 'ลำดับที่ KPI',
      '50': 'รายละเอียด KPI',
      '60': 'เป้าหมายที่กำหนด',
      '70': 'หน่วยชี้วัด',
      '80': 'มูลค่า',
      '90': 'Target Date',
      '100': 'Weight',
      '110': 'มูลค่าที่ได้',
      '120': 'คะแนนที่ได้',
      '130': 'คะแนนสุทธิ',
      '140': 'รายละเอียดงานที่ต้องทำ',
      '150': 'ข้อที่',
      '160': 'รายละเอียด',
      '170': 'งานที่ทำเสร็จ'
    },
    'HRCO2FEC1': {
      '10': 'เพิ่มข้อมูลอื่นๆ',
      '20': 'สำหรับ Table',
      '30': 'รายการข้อมูล',
      '40': 'รายละเอียด',
      '50': 'ประเภทข้อมูล',
      '60': 'ค่าข้อมูล'
    },
    'HRCO2FEC2': {
      '5': 'เพิ่มข้อมูลอื่นๆ',
      '10': 'รหัสโปรแกรม',
      '20': 'หรือ ชื่อตาราง',
      '30': 'สำหรับ Table',
      '40': 'Table Comment',
      '50': '- คอลัมน์ที่เพิ่มตอน',
      '60': ' Create จะมีคำว่า \'USR_\' อยู่ข้างหน้า',
      '70': '- Column ห้ามเกิน 8 ตัวอักษร',
      '80': 'Field Name',
      '90': 'หมายเหตุ',
      '100': 'ประเภทข้อมูล',
      '110': 'ขนาด',
      '120': 'จำนวนเต็ม',
      '130': 'ทศนิยม',
      '140': 'Primary (Y,N)',
      '150': 'Standard (Y,N)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms15e.js